import hrmStore from "../hrm/store";
import payrollStore from "../payroll/store";
import attendanceStore from "../attendance/store";
import performanceStore from "../performance/store";

import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    pageSizes: [5, 10, 20, 30, 40],
    employeeHomeProfile: {
      attendanceStatistics: {},
    },
  },
  actions,
  mutations,
  modules: {
    hrm: hrmStore,
    payroll: payrollStore,
    attendance: attendanceStore,
    performance: performanceStore,
  },
};
